import { Stack } from '@jarvis/web-stratus-client'

/**
 * Returns the base URL for the 123 stack environment based on the provided stack type.
 *
 * @param {Stack} stack - The stack environment type (dev, stage and prod).
 * @returns {string} The corresponding base URL for the specified stack environment.
 */
const get123Stack = (stack) => {
  let url = ''
  switch (stack) {
    case Stack.stage:
      url = 'https://123-stage.hpoobe.com'
      break
    case Stack.prod:
      url = 'https://123.hp.com'
      break
    default:
      url = 'https://123-test.hpoobe.com'
  }
  return url
}

export default get123Stack
